// extracted by mini-css-extract-plugin
export default {"root":"fotoBlock_root__LKO5Y","imageFooter":"fotoBlock_imageFooter__pjI90","FotoBlockMobile":"fotoBlock_FotoBlockMobile__w92kS"};